export default {
    integrationJob: [],
    integrationJobContent: []
};
